import { gql } from "@apollo/client";

// ==========================================
// PROPOSALS - QUERIES
// ==========================================

export const GET_ALL_PROPOSALS = gql`
  query GetAllProposals {
    getAllProposals {
      id
      companyName
      slug
      title
      status
      createdAt
      sentAt
      fullySignedAt
      customPagePath
    }
  }
`;

export const GET_PROPOSAL = gql`
  query GetProposal($id: ID!) {
    getProposal(id: $id) {
      id
      companyName
      slug
      title
      agreementMarkdown
      customPagePath
      notes
      status
      createdAt
      projectId
      draftBillId
      scheduledPayments {
        billId
        daysAfterPrevious
        description
      }
    }
  }
`;

export const GET_PROPOSAL_BY_SLUG = gql`
  query GetProposalBySlug($slug: String!) {
    getProposalBySlug(slug: $slug) {
      id
      companyName
      title
      agreementMarkdown
      status
      projectId
      draftBillId
      scheduledPayments {
        billId
        daysAfterPrevious
        description
      }
    }
  }
`;

export const PUBLIC_GET_PROPOSAL = gql`
  query PublicGetProposal($slug: String!, $tenantId: String!) {
    publicProposal(slug: $slug, tenantId: $tenantId) {
      id
      companyName
      title
      agreementMarkdown
      status
      projectId
      draftBillId
      scheduledPayments {
        billId
        daysAfterPrevious
        description
      }
    }
  }
`;

export const GET_PROPOSAL_SIGNATURES = gql`
  query GetProposalSignatures($proposalId: ID!) {
    getProposalSignatures(proposalId: $proposalId) {
      id
      signerName
      signerEmail
      signerRole
      signedAt
      ipAddress
    }
  }
`;

export const GET_PROPOSAL_SIGNATURES_FULL = gql`
  query GetProposalSignaturesFull($proposalId: ID!) {
    getProposalSignatures(proposalId: $proposalId) {
      id
      signerName
      signerEmail
      signerRole
      signatureImage
      signatureImageUrl
      signatureImageCid
      signedAt
      ipAddress
      emailVerified
      phoneVerified
    }
  }
`;

// ==========================================
// PROPOSALS - MUTATIONS
// ==========================================

export const CREATE_PROPOSAL = gql`
  mutation CreateProposal($input: CreateProposalInput!) {
    createProposal(input: $input) {
      id
      companyName
      slug
      title
      status
    }
  }
`;

export const UPDATE_PROPOSAL = gql`
  mutation UpdateProposal($id: ID!, $input: UpdateProposalInput!) {
    updateProposal(id: $id, input: $input) {
      id
      companyName
      slug
      title
      status
    }
  }
`;

export const DELETE_PROPOSAL = gql`
  mutation DeleteProposal($id: ID!) {
    deleteProposal(id: $id)
  }
`;

export const CLEAR_PROPOSAL_SIGNATURES = gql`
  mutation ClearProposalSignatures($proposalId: ID!) {
    clearProposalSignatures(proposalId: $proposalId)
  }
`;

export const REQUEST_PROPOSAL_EMAIL_VERIFICATION = gql`
  mutation RequestProposalEmailVerification($input: RequestProposalEmailVerificationInput!) {
    requestProposalEmailVerification(input: $input)
  }
`;

export const VERIFY_PROPOSAL_EMAIL = gql`
  mutation VerifyProposalEmail($input: VerifyProposalEmailInput!) {
    verifyProposalEmail(input: $input)
  }
`;

export const SIGN_PROPOSAL_MUTATION = gql`
  mutation SignProposal(
    $proposalId: ID!
    $clientId: ID
    $signerName: String!
    $signerEmail: String!
    $signerRole: String
    $signatureImage: String!
    $emailVerificationCode: String
    $postmarkMessageId: String
    $signerPhone: String
    $phoneVerificationCode: String
  ) {
    signProposal(
      proposalId: $proposalId
      clientId: $clientId
      signerName: $signerName
      signerEmail: $signerEmail
      signerRole: $signerRole
      signatureImage: $signatureImage
      emailVerificationCode: $emailVerificationCode
      postmarkMessageId: $postmarkMessageId
      signerPhone: $signerPhone
      phoneVerificationCode: $phoneVerificationCode
    ) {
      id
      signerName
      signedAt
      emailVerified
      phoneVerified
    }
  }
`;
